import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

const initialState = {
  data: {
    rewardRules: null,
    basicRules: null,
    rankingExcitation: null,
  },
}

export const getRankIntroduction = createAsyncThunk<any, any>(
  'getRankIntroduction',
  async (arg, store) => {
    return req(
      '/task/get_ranking_introduction',
      // @ts-ignore
      {...arg},
      store,
      false,
      null
    )
  }
)

export const reportSlice = createSlice({
  name: 'rank',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRankIntroduction.fulfilled, (state, action) => {
      return {
        data: action.payload,
      }
    })
  },
})

export default reportSlice.reducer
